import { createEntityAdapter } from '@reduxjs/toolkit';

const zonePlacementsAdapter = createEntityAdapter();

export default zonePlacementsAdapter;
